var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('div',{class:['resp-container', _vm.displayView, _vm.iframeGameVersionClass]},[_c('iframe',{ref:"iframe",staticClass:"resp-iframe",attrs:{"src":_vm.src,"allowfullscreen":"","scrolling":"no"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }